<template>
  <div class="toast">
    <img
      class="icon-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/dbafe432ea8f7bafb6b81989bf6efc9b_wh=270_273.png"
      alt=""
    />
    <div v-if="toastData">
      <div class="title">非常抱歉！</div>
      <div class="desc">{{ toastData.desc }}</div>
      <div class="btn confirm" @click="bindConfirm">{{
        toastData.confirmText
      }}</div>
      <div class="btn cancel" @click="bindClose">关闭</div>
      <div class="close" @click="bindClose"
        ><span class="iconfont icon-cha"></span
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 1
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonData: {
        3: {
          desc: '需开通健萌会员卡，才可参与活动',
          confirmText: '我要参与',
          url: 'https://work.weixin.qq.com/ca/cawcdee55b003a17af?customer_channel=qywx_ca:108363690'
        },
        2: {
          desc: '当前会员卡不符合活动参与资格',
          confirmText: '获取更多福利',
          url: 'https://work.weixin.qq.com/ca/cawcde6ce4bf9ab8f1?customer_channel=qywx_ca:108413830'
        }
      }
    }
  },
  computed: {
    toastData() {
      return this.buttonData[this.type] || null
    }
  },
  watch: {},
  created() {},
  methods: {
    bindClose() {
      this.$emit('close')
    },
    bindConfirm() {
      let value =
        this.type == 2
          ? 'CLICK_JM_EVENTS_kcdk_cmhytc'
          : 'CLICK_JM_EVENTS_kcdk_fhytc'
      this.$http.bindH5UMA('CLICK_JM_EVENTS_kcdk_tc', value)
      setTimeout(() => {
        location.href = this.toastData.url
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  position: relative;
  width: 280px;
  text-align: center;
  background: linear-gradient(180deg, #ffecb8 0px, #ffffff 180px);
  border-radius: 12px;
  padding: 61px 20px 27px;
  .icon-image {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -40%);
    width: 90px;
    height: 91px;
    object-fit: contain;
  }
  .title {
    font-weight: bold;
    font-size: 20px;
    color: #303038;
    line-height: 26px;
    margin-bottom: 6px;
  }
  .desc {
    font-size: 14px;
    color: rgba(48, 48, 56, 0.7);
    line-height: 22px;
    margin-bottom: 24px;
  }
  .btn {
    height: 44px;
    background: #f31b27;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
  }
  .cancel {
    margin-top: 16px;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    font-weight: bold;
    color: #050b27;
  }
  .close {
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #fff;
    left: 50%;
    transform: translate(-50%, 100%);
    bottom: -30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-size: 14px;
      color: #fff;
    }
  }
}
</style>
